<template>
  <div class="svgPlot-div imgTree">
    <div class="search-top">
      <el-input size="small" placeholder="快速搜索" v-model="filterText"> </el-input>
    </div>
    <div class="tree-content">
      <el-tree
        :default-expanded-keys="defaultExpandedCids"
        @node-click="nodeClick"
        :filter-node-method="filterNode"
        :data="treeData"
        node-key="title"
        ref="tree"
        highlight-current
        :props="defaultProps"
      >
      </el-tree>
    </div>

    <div v-show="pics.length > 0" class="wrapper">
      <div
        v-for="(item, index) in pics"
        :class="selectedItem.icon == item.icon ? 'active' : ''"
        class="item"
      >
        <el-tooltip>
          <div slot="content">名称：{{ item.title }}<br />编码：{{ item.code }}</div>
          <el-image
            @click="drawImg(item)"
            :src="NG_Server + '/gisData/svg/' + item.icon"
            :fit="fit"
          ></el-image>
        </el-tooltip>
      </div>
    </div>
    <div class="imgTree-bottom">
      <el-button @click="save" class="base-button" size="mini" type="primary"
        >确定</el-button
      >
      <el-button @click="edit" class="base-button" size="mini" type="primary"
        >编辑</el-button
      >
    </div>
  </div>
</template>
<script>
import tree from "../MilitaryPlot/tree.json";
import treeData from "../MilitaryPlot/treeData.json";
import imgEdit from "./imgEdit.vue";

tree.unshift(treeExt); // 在数组的第一项插入对象
treeData.unshift(treeDataExt); //插入数据

export default {
  props: ["subData"],
  data() {
    return {
      selectedItem: {},
      NG_Server: NG_Server,
      fit: "fill",
      pics: [],
      filterText: "",
      treeData: [],
      defaultExpandedCids: ["军队标号"],
      defaultProps: {
        children: "children",
        label: "title",
      },
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.treeData = tree;
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    callbackEdit(plot) {},
    getPickEnity(pick) {
      if (Cesium.defined(pick) && pick.id) {
        return pick.id;
      }

      return null;
    },
    save() {
      this.selectedItem.imageUrl = NG_Server + "/gisData/svg/" + this.selectedItem.icon;
      this.$bus.$emit("saveBillBoardData", this.selectedItem);
      this.$parent.close();
    },
    edit() {
      if (this.selectedItem.icon) {
        this.$dialog.open({
          id: "图标编辑",
          title: "图标编辑",
          area: {
            height: "800px",
            width: "300px",
          },
          content: {
            type: "vue",
            subCom: imgEdit,
            subData: this.selectedItem,
          },
        });
        this.$parent.close();
      }
    },
    drawImg(item) {
      this.selectedItem = item;
      var img = NG_Server + "/gisData/svg/" + item.icon;
    },
    nodeClick(item, node, el) {
      this.pics = [];
      //叶子节点
      if (!item.children || item.children.length < 1) {
        var file = this.getItemByName(treeData, item.title);
        if (file) {
          this.pics = file.children;
        }
      }
    },
    getItemByName(list, name) {
      if (!list) {
        return;
      }
      var item;
      for (var i = 0; i < list.length; i++) {
        var element = list[i];
        if (element.title == name) {
          item = element;
          return item;
        }
        item = this.getItemByName(element.children, name);
        if (item) {
          return item;
        }
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    },
  },
};
</script>

<style lang="scss" scoped>
.imgTree {
  width: 100%;
  position: relative;
  height: 100%;
}
.search-top {
  margin-bottom: 10px;
}

.imgTree-bottom {
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.tree-content {
  max-height: 40vh;
  overflow: auto;
  // border: solid 1px #e4e7ed;
}

.wrapper {
  margin-top: 20px;
  padding: 16px 16px 16px 16px;
  display: grid;
  grid-gap: 16px;
  // border: solid 1px #e4e7ed;
  border-top: 1px solid rgba(#fff, 0.2);
  max-height: 20vh;
  overflow-y: auto;
  overflow-x: hidden;
  grid-template: repeat(4, 1fr) / repeat(4, 1fr);
}

.item {
  text-align: center;
  border: 1px solid rgba(#fff, 0.5);
  width: auto;
  padding: 2px 4px;
  cursor: pointer;
  .el-image {
    height: 40px;
  }
}
.active {
  border: 1px solid #027cfa !important;
}
</style>

<style lang="scss">
.svgPlot-div {
  .el-input__inner {
    background-color: transparent !important;
    border: 1px solid rgba(#fff, 0.2);
    color: #ffffff;
  }

  .el-tree__empty-text {
    color: #ffffff;
  }

  .el-tree {
    background: none;
    color: #ffffff;
  }

  .el-tree-node__content:hover,
  .el-upload-list__item:hover {
    background-color: transparent !important;
    color: #83e9ff;
  }

  .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: transparent !important;
    color: #83e9ff;
  }

  .el-tree-node:focus > .el-tree-node__content {
    background-color: transparent !important;
  }
}
</style>
